<template>
<div class="container">
    <div class="tabs">
        <ul class="nav  nav-tabs mb-3" id="pills-tab" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" 
            id="pills-home-tab" 
            data-toggle="pill"
            href="#pills-home" 
            role="" 
            aria-controls="" 
            aria-selected="true">
            Campo de Bosque 3D</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                Sala Indoor</a>
        </li>
        
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <!-- TAB 1 -->
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="row">
                    <div class="col-sm">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9894.645344883971!2d1.9924466119596458!3d41.50573477786082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a491f722405f7b%3A0x635b4cb8698919b3!2sArc%20Rubi!5e0!3m2!1ses!2ses!4v1608652502540!5m2!1ses!2ses" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    </div>
                    <div class="col-sm">
                        <h3>Dos circuitos de bosque  3D</h3>
                        <p>Con 24 dianas 3D por circuito</p>
                        <p>Horario:</p>
                        <ul>
                            <li>Lun - mier: 17:00 a 21:00</li>
                            <li>Lun - mier: 17:00 a 21:00</li>
                            <li>Lun - mier: 17:00 a 21:00</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- FI TAB 1 -->
            <!-- TAB 2 -->
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <div class="row">
                    <div class="col-sm">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2989.3576110117424!2d2.0269618158424727!3d41.474846198530905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a49170b55494ff%3A0xdb9146a030a0d518!2sSala%20Tiro%20con%20Arco%20Rubi!5e0!3m2!1ses!2ses!4v1608652401887!5m2!1ses!2ses" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    </div>
                    <div class="col-sm">
                        <h3>Sala Indoor</h3>
                        <p>Más de 500m de sala para entrenar a cubierto</p>
                        <p>Horario:</p>
                        <ul>
                            <li>Lun - mier: 17:00 a 21:00</li>
                            <li>Lun - mier: 17:00 a 21:00</li>
                            <li>Lun - mier: 17:00 a 21:00</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- FI TAB 1 -->
        
        </div>
    </div>

</div>
</template>

<script>
    export default {
        name: 'DescriptionTabs',
        components: {
        }
    }
</script>